<template>
  <v-card :height="fullscreen ? $vuetify.breakpoint.height + 'px' : 'auto'" tabindex="-1" @keydown.esc="$emit('close')" @keydown.enter="$emit('enter')">
    <v-toolbar card light dense flat>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')" tabindex="-1">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card v-if="!listable" flat class="scroll-y" :max-height="calcDialogScroll(deltas[0]+delta, (deltas[1] || deltas[0]) + delta)">
      <slot></slot>
    </v-card>
    <v-card-scroll v-if="listable" flat :height="calcDialogScroll(deltas[0] + delta, (deltas[1] || deltas[0]) + delta)">
      <slot></slot>
    </v-card-scroll>  
    <v-card-actions v-if="$slots.actions">
      <slot name="actions"></slot>
      <span tabindex="0" v-on:focus="firstFocus()"></span>
    </v-card-actions>  
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import vCardScroll from '../common/CardScroll'
  export default {
    name: 'btn-form',
    components: {vCardScroll},
    data: () => ({
      delta: 48 + 52
    }),
    props: {
      title: {
        type: String,
        default: ''
      },
      mode: {
        default: null
      },
      deltas: {
        default: () => [0]
      },
      listable: {
        type: Boolean,
        default: false
      }
    },
    created () {
    },
    mounted () {
      this.setFocus()
    },
    watch: {
      mode: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setFocus()
        }
      }
    },
    computed: {
      ...mapGetters({
        fullscreen: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      })
    },
    methods: {
      setFocus () {
        this.$nextTick(function () {
          if (!this.$el.contains(document.activeElement)) {
            this.$el.focus()
          }
        })
      },
      firstFocus () {
        let input = this.$el.querySelector('input')
        console.log('firstFocus', input)
        if (input) {
          input.focus()
        } else {
          this.$el.focus()
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// BtnForm.vue?1be47640